import { getCategoryById } from "@dana/Services/DanaCategoryService";
import { GetCategoryByIdApiParameter } from "@insite/client-framework/Services/CategoryService";

export const getSearchParams = () => {
    if (typeof window !== "undefined") {
        return new URLSearchParams(window.location.search);
    }
    return null;
};
  export const getCurrentCategoryById = async (categoryId: string) => {
        const parameter = { id: categoryId } as GetCategoryByIdApiParameter;
        const categoryModel = await getCategoryById(parameter);
        return categoryModel;
    }